export const tenantSettings = [
    { key: 'tenant6_api', name: 'fib', theme: 'fibConfig' },
    { key: 'tenant7_api', name: 'neo', theme: 'neoConfig' },
    { key: 'tenant37_api', name: 'nass', theme: 'nassConfig' },
    { key: 'tenant12_api', name: 'riyad', theme: 'riyadConfig' },
];

export const defaultTenantKey = tenantSettings[0];
